<template>
    <div class="pa-2">
        <h2>Add Expected Transaction</h2>
       <expected-transaction-form :expectedTransaction="expectedTransaction" @save="save" />
    </div>
</template>

<script>
import { apiPost } from '../../../dal';
import ExpectedTransactionForm from '../components/ExpectedTransactionForm.vue'
export default {
  components: {  ExpectedTransactionForm },
  data() {
        return {
            expectedTransaction: {
                TRANSACTION_DATE: null,
                SUPPLIER: null,
                AMOUNT: null,
                DESCRIPTION: "",
                CATEGORY_ID: null,
                ID: null,
                TRANSACTION_ID: null
            }
        };
    },
    
    methods: {
        save(expectedTransaction) {
            apiPost("expected-transactions", expectedTransaction).then(() => {
                this.$store.dispatch("getExpectedTransactions");
                this.$router.push({ name: "expectedTransactions" });                
            });                        
        }
    }
}



</script>


<style>

</style>